module.exports = __webpack_public_path__ + "img/ico_subir.86a5305f.svg";